import axios from 'axios';
import { Event } from '../../domain/game/Event';

export class EventsService
{
    public getEvents(): Promise<Event[]> {
        return axios.get('/api/events/').then((response) => response.data);
    }

}